<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :loading="modalLoading"
      :data="queryVolumesByGroupIdList"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="volumeDelmodal = true"
            v-hasPermission="[
              'permissionsConfigurationManagement:resourcePermission:delete_disc'
            ]"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <Modal v-model="volumeDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ volumeName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="deleteVolume()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import utils from "../../../../utils/utils.js";
var tableVolumes = {};
export default {
  name: "TableVolumes",
  props: ["getAccountType"],
  data() {
    return {
      accountType: "",
      accountName: "",
      instanceId: "",
      volumeId: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      volumeName: "",
      modalLoading: true,
      volumeDelmodal: false,
      isDisable: false,
      state: [
        "creating",
        "available",
        "in-use",
        "deleting",
        "deleted",
        "error"
      ],
      columns: [
        {
          title: this.$t(
            "permission_configuration_management.group.accountName"
          ),
          key: "accountName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.accountType"
          ),
          key: "accountTypeName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.instanceID"
          ),
          key: "instanceId"
        },
        {
          title: this.$t("permission_configuration_management.group.volumeID"),
          key: "volumeAwsId"
        },
        {
          title: this.$t("permission_configuration_management.group.name"),
          key: "name"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.deviceName"
          ),
          key: "deviceName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.diskStorage"
          ),
          key: "capacity"
        },
        {
          title: this.$t("permission_configuration_management.group.type"),
          key: "type"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.readingSpeed"
          ),
          key: "iops"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.encryption"
          ),
          key: "encrypted"
        },
        {
          title: this.$t("permission_configuration_management.group.region"),
          key: "region"
        },
        {
          title: this.$t("permission_configuration_management.group.status"),
          key: "stateName"
        },
        {
          title: this.$t("common.operation"),
          slot: "actions"
        }
      ],
      queryVolumesByGroupIdList: []
    };
  },
  beforeCreate: function() {
    tableVolumes = this;
  },
  methods: {
    // 点击备份目标的时候显示卷列表
    queryVolumesByGroupId: function() {
      eventBus.$on("volumeId", function(val) {
        tableVolumes.volumeId = val;
      });
      eventBus.$on("accountName", function(val) {
        tableVolumes.accountName = val;
      });
      eventBus.$on("accountType", function(val) {
        tableVolumes.accountType = val;
      });
      eventBus.$on("instanceId", function(val) {
        tableVolumes.instanceId = val;
      });
      tableVolumes.$api.groupVolumeRelation
        .queryVolumeByGroupId({
          groupId: this.$route.query.id,
          pageNum: this.current,
          pageSize: this.pageSize,
          volumeAwsId: tableVolumes.volumeId,
          accountType: this.getAccountType,
          accountName: tableVolumes.accountName,
          instanceId: tableVolumes.instanceId
        })
        .then(res => {
          this.modalLoading = false;
          this.queryVolumesByGroupIdList = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(res => {
          // 如果列表里没数据 返回
          this.queryVolumesByGroupIdList = undefined;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableVolumes.queryVolumesByGroupId();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableVolumes.queryVolumesByGroupId();
    },
    // 显示所有数据
    showAllVolume: function() {
      tableVolumes.queryVolumesByGroupId();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.volumeName = this.queryVolumesByGroupIdList[index].name;
    },
    // 删除Volume
    deleteVolume: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      // 删除卷
      tableVolumes.$api.groupVolumeRelation
        .deleteByGroupIdAndVolumeId({
          groupId: this.$route.query.id,
          volumeId: this.queryVolumesByGroupIdList[lineIndex].id
        })
        .then(res => {
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableVolumes.queryVolumesByGroupId();
            this.isDisable = false;
            this.volumeDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/TableVolumes.vue